import { VisitHistoryElectronicReferral } from '@dreryk/egabinet-visit-frontend-api';

type LocationSpecialityCellProps = {
   readonly referral: VisitHistoryElectronicReferral;
};

export const LocationSpecialityCell = (props: LocationSpecialityCellProps): JSX.Element => {
   return (
      <>
         {props.referral.locationSpecialtyCode || props.referral.diagnosticLabCode || props.referral.medicalClinicCode}{' '}
         {props.referral.locationSpecialtyName || props.referral.diagnosticLabName || props.referral.medicalClinicName}
      </>
   );
};
